<template>
    <div class="position-fixed modall d-flex align-items-center justify-content-center">
        <div v-if="Object.keys(productVariant).length > 0" class="bg-white row position-relative ">
            <div class="close position-absolute" @click="$store.commit('forceCloseModal')">x</div>
            <div class="col-md-6 d-flex align-items-center justify-content-center h-100">
                <img v-if="productVariant?.immagine?.[0]?.path" :src="productVariant?.immagine?.[0]?.path" />
                <div v-else>
                    {{$t('product.noImage')}}
                </div>
            </div>
            <div class="col-md-6 d-flex justify-content-center flex-column">
                <h1 class="bolded">{{productVariant?._prodotto?.[0]?.nome}}</h1>
                <p class="bolded mt-3 border-bottom pb-3 mb-5">
                    <template v-if="type ==='single'">
                        <span class="fw-bold">{{ $convertCurrency(productVariant?.prezzo) }}</span>
                    </template>
                   <template v-else-if="didAuctionEnd">
                        <template v-if="type === 'auction'">{{$t('product.currentBid')}} </template> {{$convertCurrency(currentBid)}}
                   </template>
                    <template v-else>
                        {{$t('auctionStatus.endedAuction')}}
                   </template>
                </p>
                <div class="spacing">
                    SKU: {{productVariant?.codice}}
                </div>
                <!-- <div class="product-bid-categories spacing d-flex">
                    <span class="text-secondary">Categories: </span>
                    <FilterListTags :comma="true" class="list-category d-flex ms-2 m-0 p-0" :items="[]" />
                </div> -->
                <div class="product-bid-tags negative-spacing d-flex">
                    <span class="text-secondary">{{$t('product.tags')}} </span>
                    <FilterListTags :comma="true" class="ms-2  list-tags d-flex m-0 p-0" :items="[{name: `${productVariant?.taglia}`}]" />
                </div>
            </div>
        </div>
        <div v-else>
            <div class="container loader-wrapper d-flex justify-content-center align-items-center">
                <div class="loader"></div>
            </div>
        </div>
    </div>
</template>

<script>
import FilterListTags from "../../atoms/Filter/FilterListTags.vue"
import { getBidDetailService } from "../../../services/auctionService";
import { allProductMixin } from "../../../composables/allProductMixin";
export default {
    components: {
        FilterListTags
    },
    mixins: [allProductMixin],

    props: {
        id: {
            type: String
        }
    },
    data() {
        return{
            productVariant: {},
            type: 'single',
            astaId: '',
            bidDetail: {},
        }
    },
    computed: {
        didAuctionEnd() {
            if(this.type == "auction"){
                const endDate = this.bidDetail?.dataFine;
                return new Date(endDate) > new Date()
            }
            return false;
        },
        isAuctionProduct() {
            return this.productVariant?._astaCorrente?.length > 0;
        }
    },
    mounted() {
        
    },
    watch: {
        allProducts() {
            this.init();
        }
    },
    methods: {
        async init() {
            let id = this.id.split("-");

            this.productVariant = this.getProduct(id[1], id[2]);

            var isAuctionProduct = this.isAuctionProduct;
            if(isAuctionProduct){
                this.type = 'auction';
                this.astaId = this.productVariant?._astaCorrente?.[0];
                await this.getBidDetail();
            }
        },
        async getBidDetail() {
            let astaId = this.astaId;
            if (!astaId) return;

            let res = await getBidDetailService({
                astaId: astaId
            });
            this.bidDetail = res.asta || {};
        },
    }
}
</script>

<style scoped="scoped">
.bolded {
    font-size: 24px !important;
    font-weight: bold;
}
.close {
    cursor:pointer;
    right:10px;
    top:10px;
    width: fit-content;
}
.modall > .row {
    width:1000px;
    height:480px;
}
img {
    object-fit: contain;
    width: 100%;
    height: 100%;
}
.spacing {
    margin:3px 0;
}
.negative-spacing {
    margin-top:-5px;
}
:deep(.item ) {
    font-weight: bold;
    color:#484848 !important;
}
</style>
<style>
  .loader-wrapper {
    min-width: 100vw;
    min-height: 100vh;
  }
  .loader-wrapper .loader {
    border: 4px solid #f3f3f3;
    border-top: 4px solid #3498db;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    animation: spin 1s linear infinite;
    margin: 100px auto;
  }
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
</style>